//TODO : Refactor after ai
import type { HTMLAttributes, ReactNode } from "react";
import type { ToneColor } from "../types";
import { FeaturedIcon } from "./FeaturedIcon";

export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  icon?: ReactNode;
  title: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
  color?: ToneColor;
  size?: "md" | "lg";
}

/** Zero-data placeholder: icon, heading, copy, action. */
export function EmptyState({
  icon,
  title,
  children,
  actions,
  color = "neutral",
  size = "md",
  className = "",
  ...rest
}: EmptyStateProps) {
  const big = size === "lg";
  return (
    <div
      className={className}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: 16,
        padding: big ? "64px 24px" : "40px 24px",
      }}
      {...rest}
    >
      <FeaturedIcon color={color} size={big ? "2xl" : "xl"} radius="circle">
        {icon}
      </FeaturedIcon>
      <div style={{ maxWidth: 420, display: "flex", flexDirection: "column", gap: 6 }}>
        <div
          style={{
            font: big ? "var(--t-h6)" : "var(--t-subtitle)",
            fontWeight: 600,
            color: "var(--text-primary)",
          }}
        >
          {title}
        </div>
        {children && (
          <p style={{ font: "var(--t-paragraph-s)", color: "var(--text-tertiary)" }}>
            {children}
          </p>
        )}
      </div>
      {actions && <div style={{ display: "flex", gap: 12, marginTop: 4 }}>{actions}</div>}
    </div>
  );
}
